import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function BackHome() {
  return (
    <Link to="/" data-testid="back-home-link"
      className="absolute top-4 left-4 z-20 inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors">
      <ArrowLeft className="w-4 h-4" /> Home
    </Link>
  );
}
